import React, { useEffect, useState } from "react";
import "./ServicesCount.css";
import ServiceBody from "./ServiceBody";
import ServiceBanner from "./ServiceBanner";
import { GetContent } from "../../../Api/Api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

export default function SpecificServicesComponent() {

  const { id } = useParams(); // ✅ GET ID FROM URL
  const state = useSelector((state) => state);

  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH SERVICE CONTENT ---------------- */
  const fetchServiceContent = async () => {
    try {
      if (!id) return;

      const data = await GetContent("active", id);

      if (data?.statusCode === 200) {
        setContent(data.data);
      } else {
        setContent([]);
      }
    } catch (error) {
      console.error("Service fetch failed:", error);
      setContent([]);
    }

    setLoading(false);
  };

  /* ---------------- EFFECT ---------------- */
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchServiceContent();
  }, [id]); // ✅ Re-run when ID changes

  /* ---------------- LOADING STATE ---------------- */
  if (loading) {
    return <div className="text-center py-5">Loading service...</div>;
  }

  if (!content?.length) {
    // return <div className="text-center py-5">Service not found</div>;
  }

  /* ---------------- DYNAMIC SEO LOGIC ---------------- */
  let title = "Service | Dalmaf";
  let description = "Explore top-tier services and consulting at Dalmaf.";
  let keyword = "dalmaf, consulting, services, business";

  if (content?.length > 0 && content[0]) {
    const dataObj = content[0];
    title = dataObj.metaTitle || `${dataObj.mainServiceId?.title || 'Service'} | Dalmaf`;
    
    // Strip HTML and truncate for fallback description/keyword
    const stripHtml = (html) => {
      if (!html) return "";
      return html.replace(/<[^>]*>?/gm, '').trim();
    };
    
    let strippedContent = stripHtml(dataObj.content);
    let fallbackDesc = strippedContent.length > 160 ? strippedContent.substring(0, 160) + "..." : strippedContent;
    
    description = dataObj.metaDescription || (fallbackDesc || description);
    keyword = dataObj.metaKeyword || (fallbackDesc || keyword);
  }

  /* ---------------- JSON-LD SCHEMA ---------------- */
  const schemaOrgJSONLD = {
    "@context": "http://schema.org",
    "@type": "Service",
    "name": title,
    "description": description,
    "provider": {
      "@type": "Organization",
      "name": "Dalmaf",
      "url": "https://dalmaf.com"
    }
  };

  /* ---------------- RENDER ---------------- */
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
      </Helmet>
      <ServiceBanner contentProps={content} stateProps={state} />
      <ServiceBody contentProps={content} stateProps={state} />
    </div>
  );
}